import { DefaultImageProps } from './types';
import { PROFILE_ICON_IMAGE_URL } from './urls';

export const ProfileIconImage = ({ className, ...props }: DefaultImageProps) => (
  <img
    className={className}
    src={PROFILE_ICON_IMAGE_URL}
    alt="profile-icon"
    {...props}
  />
);
